import React, { useEffect, useState } from 'react';

import { isMobile } from 'react-device-detect';
import { Grid } from '@material-ui/core';
import { Text, PrimaryButton, SecondaryButton } from 'library';
import apiClient from 'shared/ApiClient';
import PublicJobCard from '../public-application/job-card/PublicJobCard';
import { goToPublicJobs } from './ProviderHomeConstants';
import { OtherCardsProps } from './ProviderHomeModels';
import usePublicSessionTracking, { PublicSessionEventType } from '../../shared/PublicSessionTracking';
import { Environment } from 'environmentVariables';

interface IJob {
    id: number;
    pay: number;
    start_date: Date;
    end_date: Date;
    rate_min: number;
    rate_max: number;
    days_of_week: string[];
    times_of_day: any;
    ongoing: boolean;
    pay_is_fixed: boolean;
    city: string;
    state: string;
    kid_count: number;
    pet_count: number;
    applied: boolean;
    long_term?: boolean;
    family?: any;
    transportation?: boolean;
    family_comments?: string;
    start_month?: any;
    headline?: string;
    family_name?: string;
    start_date_time?: Date;
    end_time?: any;
    request_type: string;
    job_type: number;
}

export default function ProviderTopJobs({ otherCopy, altDisplay = false, overrideClick }: OtherCardsProps) {
    const [jobs, setJobs] = useState<IJob[]>();
    const [pctMarginTop, setPctMarginTop] = useState<string>('10%');
    const [headerFontSize, setHeaderFontSize] = useState<number>(24);
    const { trackSession } = usePublicSessionTracking('Provider Top Jobs');

    useEffect(getTop3Listings, []);

    useEffect(() => {
        if (altDisplay) {
            setPctMarginTop('0%');
            setHeaderFontSize(24);
        } else {
            setPctMarginTop(isMobile ? '20%' : '10%');
            setHeaderFontSize(isMobile ? 24 : 32);
        }
    }, [altDisplay]);

    const navigateToJobs = () => {
        if (!!overrideClick) {
            overrideClick();
        } else {
            trackSession('NAVIGATE_FROM', 'To Public Jobs Page', PublicSessionEventType.User);
            goToPublicJobs();
        }
    };

    function getTop3Listings() {
        apiClient(`api/listing/top-three-listings/`)
            .then((res) => {
                setJobs(res);
            })
            .catch((error) => {
                if (Environment !== 'production') {
                    console.log(error);
                }
            });
    }
    return (
        <>
            {!!jobs ? (
                <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    xs={12}
                    style={{
                        paddingInline: '10%',
                        marginTop: '5%',
                        marginBottom: '5%',
                        paddingTop: isMobile ? 50 : 0,
                    }}
                >
                    <Grid container item alignItems="center" justify="center" style={{ marginTop: pctMarginTop }}>
                        <Text variant="h1" textStyle={{ fontSize: headerFontSize, textAlign: 'center' }}>
                            {!!otherCopy ? otherCopy : "We think you'll love these jobs:"}
                        </Text>
                    </Grid>

                    {jobs.map((job: IJob) => (
                        <PublicJobCard key={job.id} job={job} uuid={null} overrideClick={overrideClick} />
                    ))}
                    <Grid
                        container
                        item
                        alignItems="center"
                        justify="center"
                        style={{ marginTop: '10%', paddingInline: 60 }}
                    >
                        {!isMobile ? (
                            altDisplay ? (
                                <PrimaryButton
                                    onClick={navigateToJobs}
                                    buttonStyle={{ height: 50, width: 300 }}
                                    textStyle={{ fontWeight: 'bold' }}
                                >
                                    Apply for more jobs
                                </PrimaryButton>
                            ) : (
                                <SecondaryButton
                                    onClick={navigateToJobs}
                                    buttonStyle={{ height: 50, width: 300 }}
                                    textStyle={{ fontWeight: 'bold' }}
                                >
                                    View more jobs
                                </SecondaryButton>
                            )
                        ) : null}
                    </Grid>
                </Grid>
            ) : null}
        </>
    );
}
